import { render, staticRenderFns } from "./IndexTrend.vue?vue&type=template&id=0243ce28&scoped=true&"
import script from "./IndexTrend.vue?vue&type=script&lang=js&"
export * from "./IndexTrend.vue?vue&type=script&lang=js&"
import style0 from "./IndexTrend.vue?vue&type=style&index=0&id=0243ce28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0243ce28",
  null
  
)

export default component.exports